import { NgModule } from 'angular-ts-decorators';
import { DesignModule } from 'src/Foundation/Design/platform';

@NgModule({
  id: 'gn.audio.public.contentelements',
  imports: [DesignModule],
})
export class ContentelementsModule {
}
